import "./Button.css"

function Button({ children, className, variant = "default", disabled, ...props }) {
  const variantClass = variant === "outline" ? "button-outline" : "button-default"
  const buttonClass = `button ${variantClass} ${className || ""} ${disabled ? "button-disabled" : ""}`

  return (
    <button className={buttonClass} disabled={disabled} {...props}>
      {children}
    </button>
  )
}

export default Button

